module.exports = __webpack_public_path__ + "img/1557614107141677057.b108cb24.png";